import {
    NavLink,
    useParams
} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

export const IndexPageNavigation = () => {

    const {id: accountId} = useParams()
    if (!accountId) {
        throw new Error('Account id is required');
    }


    const breadcrumbs = [
            {
                title: 'Home',
                href: '/dashboard',
            }, {
                title: 'Accounts',
                href: '/accounts',
            }, {
                title: 'Account',
                href: `/accounts/${accountId}`,
            }, {
                title: 'Account Applications'
            }
        ].map((item, index) => (
            <Box key={index}> {
                item
                    .href ?
                    <NavLink to={item.href}>{item.title}</NavLink> : item.title
            }
            </Box>
        ))
    ;
    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};

